import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import { Popup, Image, Menu } from 'semantic-ui-react';

import gravatar from '../../utils/gravatar';


const propTypes = {
  email: PropTypes.string.isRequired,
  name: PropTypes.string,
  picture: PropTypes.string,
  logout: PropTypes.func.isRequired,
};

const UserControl = ({ email, picture, name, logout }) => {
  const avatar = (
    <Image
      className="link"
      size="mini"
      bordered
      shape="circular"
      src={picture || gravatar(email)}
    />
  );

  const menu = (
    <Menu text vertical>
      <Menu.Item header>{name}</Menu.Item>
      <Menu.Item onClick={logout}>
        <FormattedMessage id="login.signOut" />
      </Menu.Item>
    </Menu>
  );

  return (
    <Popup
      trigger={avatar}
      content={menu}
      on="click"
      positioning="bottom right"
    />
  );
};

UserControl.propTypes = propTypes;

export default UserControl;



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/components/userControl/UserControl.js
 **/